import { Container, Heading, Logo, Separator, Text } from '@teliaee/design-system';
import * as React from 'react';
import { getBrandNameFromUrl } from '../util/BrandUtil';

interface PageErrorBoundaryProps {
  children: React.ReactNode;
}

class PageErrorBoundary extends React.Component<PageErrorBoundaryProps> {
  public state = {
    hasError: false,
    brand: getBrandNameFromUrl(),
  };

  public componentDidCatch() {
    this.setState({ hasError: true });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div>
          <Separator spacing={'small'} color={'invisible'} />
          <Container>
            <Text>
              <Logo brand={this.state.brand} text={this.state.brand} size={'small'} />
              <Heading element={'h1'}>Kodulehel on hooldustööd!</Heading>
              <Heading element={'h4'}>Seoses hooldustöödega veebileht ei tööta.</Heading>
              <Heading element={'h4'}>Ootame Sind aga juba õige pea tagasi!</Heading>
              <Separator color={'invisible'} />
              <Heading element={'h1'}>Проводится сервисное обслуживание!</Heading>
              <Heading element={'h4'}>Вы застали нас врасплох! Как раз сейчас мы обновляем сайт.</Heading>
              <Heading element={'h4'}>Домашняя страница не работает в связи с работами по обслуживанию. Ждём Вас обратно в скором времени!</Heading>
            </Text>
          </Container>
        </div>
      );
    }
    return this.props.children;
  }
}

export default PageErrorBoundary;
